module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUBAMAAACQZWsAAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAgklEQVQI12NgAILq3UCwywDEZH5eXl4+7+8FEJtlAwOD50+XD1C29XMFFhCbBcheCaRAbL7JDQxfoGzmlwxwNoPdBCj7/f///78gxGUmwNmMJxHqeSYVwNlsQPPh6nGyr7gA2axgdzJ07/7CwNSXwAABX1jWT4EyGV7cLYIxGbJACgD1JDwxIA1dJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logout.png
// module id = 653
// module chunks = 0